import { Link } from 'react-router-dom';
import { BellIcon } from '@heroicons/react/24/outline';
import { useNotifications } from '../hooks/useNotifications';

const NotificationBell = () => {
  const { unreadCount } = useNotifications();
  return (
    <Link to="/notifications" aria-label={unreadCount ? `Notifications, ${unreadCount} unread` : 'Notifications'}
      className="relative inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-lg text-gray-600 hover:bg-blue-50 hover:text-blue-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-blue-500">
      <BellIcon className="h-6 w-6" />
      {Boolean(unreadCount) && <span aria-hidden="true" className="absolute right-0 top-0 min-w-5 rounded-full border-2 border-white bg-blue-600 px-1 text-center text-[11px] font-semibold text-white">{unreadCount! > 99 ? '99+' : unreadCount}</span>}
    </Link>
  );
};

export default NotificationBell;
